import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

import { ChatAppMessageLinks } from "../chat-app.model";

@Component({
  selector: "message-links",
  templateUrl: "./message-links.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageLinksComponent {
  @Input() message!: ChatAppMessageLinks;

  @Output() readonly clicked = new EventEmitter<string>();

  onClick(message: string) {
    this.clicked.emit(message);
  }
}
